import classNames from 'classnames'
import { useTranslation } from 'next-i18next'

import useEddExp from '@src/quince-site-common/src/hooks/edd/hooks/useEddExp'
import { generateEDDLabel } from '@src/quince-site-common/src/hooks/edd/utils/edd.utils'
import { EDDDetails } from '@src/quince-site-common/src/services/eddService/eddService.types'

import styles from './product-card-footer.module.scss'
export function BottomTagComponent({
  isWhiteGloveDelivery,
  eddDetails,
}: {
  isWhiteGloveDelivery?: boolean
  eddDetails?: EDDDetails
}) {
  const { t: tCommon } = useTranslation('common')
  const eddLabel = generateEDDLabel(eddDetails, tCommon)
  const { isEddExpEnabled: isEDDExpEnabled } = useEddExp()

  return (
    <>
      {eddLabel && isEDDExpEnabled && <div className={classNames(styles.bottomTag, styles.eddLabel)}>{eddLabel}</div>}
      {isWhiteGloveDelivery ? <div className={styles.whiteglove}>{tCommon('free_white_glove_delivery')}</div> : null}
    </>
  )
}
